import React, { useEffect } from 'react';
import AudioPlayer, { RHAP_UI } from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import { useAudio } from './AudioContext';
import { useRadio } from './radiodata';

const AudioPlayerPanel = () => {
  const { audioState, dispatch } = useAudio();
  const { trackTitle } = useRadio();

  useEffect(() => {
    localStorage.setItem('audioState', JSON.stringify(audioState));
  }, [audioState]);

  useEffect(() => {
    const savedAudioState = localStorage.getItem('audioState');
    if (savedAudioState) {
      dispatch({ type: 'SET_AUDIO_STATE', payload: JSON.parse(savedAudioState) });
    }
  }, [dispatch]);

  return (
    <div className="grid grid-cols-8 max-h-20 fixed bottom-0 left-0 right-0 bg-zinc-800 p-2  z-10">
      {/* Поместите AudioPlayer внутрь панели */}
      <div className=" sm:col-start-2 sm:col-end-2 max-h-20 items-center  ">
        <AudioPlayer
          src={audioState.src}
          autoPlayAfterSrcChange={audioState.autoPlayAfterSrcChange}
          customAdditionalControls={audioState.customAdditionalControls}
          onPlay={() => dispatch({ type: 'SET_AUDIO_STATE', payload: { isPlaying: true } })}
          onPause={() => dispatch({ type: 'SET_AUDIO_STATE', payload: { isPlaying: false } })}
          header="Dj radio"
          layout="horizontal-reverse"
          preload="none"
          customVolumeControls={[]}
          showJumpControls={false}
          customProgressBarSection={[
            RHAP_UI.CURRENT_TIME,
          ]}
          customControlsSection={[
            RHAP_UI.MAIN_CONTROLS,
          ]}
        />
      </div>
      <div className=" flex items-center overflow-hidden col-start-4 md:col-start-3 col-end-8 ">
        {/* Ваши дополнительные элементы панели могут быть добавлены здесь */}
        <span className="text-white mr-2    marquee">{trackTitle}</span>
      </div>
      {/* Дополнительный элемент справа */}
 
    </div>
  );
};

export default AudioPlayerPanel;
